import { APP } from '@/constants/testIds';
import { Wheat } from 'lucide-react';

const Header = () => (
  <header className="border-b border-border/60 bg-white/80 backdrop-blur-md sticky top-0 z-40">
    <div className="max-w-[1400px] mx-auto px-4 sm:px-8 py-3 flex items-center gap-4">
      <img
        data-testid={APP.headerLogo}
        src="/logos/icrisat_logo.png"
        alt="ICRISAT"
        className="h-12 w-auto"
      />
      <div className="flex-1 min-w-0">
        <h1
          data-testid={APP.headerTitle}
          className="font-display text-2xl sm:text-3xl leading-tight text-icrisat-green"
        >
          AgriAgent
        </h1>
        <p className="text-xs sm:text-sm text-muted-foreground -mt-0.5">
          for Small Holder Farmers · <span className="hidden sm:inline">Telangana crop-decision lifecycle · </span>Powered by ICRISAT
        </p>
      </div>
      <div className="hidden md:flex items-center gap-2 text-icrisat-green">
        <Wheat className="h-5 w-5" />
        <span className="text-sm font-medium">9 advisories · 8 crops</span>
      </div>
    </div>
  </header>
);

export default Header;
